import { createTranslator } from 'use-intl/core'
import { DEFAULT_LOCALE, isLocale, type Locale } from './config'

const loaders = {
  fr: () => import('../../messages/fr.json'),
  en: () => import('../../messages/en.json'),
} satisfies Record<Locale, () => Promise<{ default: Record<string, unknown> }>>

export async function loadMessages(locale: Locale) {
  return (await loaders[locale]()).default
}

export async function getTranslations(opts: { locale?: string; namespace: string }) {
  const locale = opts.locale && isLocale(opts.locale) ? opts.locale : DEFAULT_LOCALE
  const messages = await loadMessages(locale)
  return createTranslator({ locale, messages, namespace: opts.namespace } as never)
}
